import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getJobDetails } from 'api/apiHelper';
import { JobOpeningType } from 'types/careers-types';
import EditJobForm from 'features/carrers/EditJobForm';

const EditJobDetails = () => {
  const { slug } = useParams<{ slug: string }>();
  const [jobDetails, setJobDetails] = useState<JobOpeningType | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (slug) {
      fetchJobDetails(slug);
    }
  }, [slug]);

  const fetchJobDetails = async (id: string) => {
    try {
      const response = await getJobDetails(id);
      const fetchedJob = response.data;
      setJobDetails(fetchedJob);
      setIsLoading(false);
    } catch (err) {
      console.error('Failed to fetch job details:', err);
      setError('Failed to load the job details.');
      setIsLoading(false);
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!jobDetails) return <div>No job details available.</div>;

  return (
    <div>
      <EditJobForm key={slug} jobDetails={jobDetails} />
    </div>
  )
}

export default EditJobDetails;
